<!-- <mat-drawer-container class="block w-screen h-screen">
    <mat-drawer
        #accountDrawer
        [mode]="drawerMode"
        position="end"
        (closed)="closeDrawer()"
        [style.width]="drawerWidth"
    >
        <router-outlet name="drawer"></router-outlet>
    </mat-drawer>

    <router-outlet></router-outlet>
</mat-drawer-container> -->
<router-outlet></router-outlet>

<!-- Progressive web app chrome: rendered outside of the layouts so it is available on every screen,
     including the sign-in pages which use the empty layout. -->
<pwa-offline-indicator></pwa-offline-indicator>
<pwa-install-prompt></pwa-install-prompt>
